import React from "react";
import Svg, { Path } from "react-native-svg";

const Fire = (props) => (
  <Svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M5.1827 15.8559C4.42803 14.9983 3.6734 14.1065 3.19314 13.0431C2.71292 11.9111 2.5757 10.6076 2.81582 9.3727C3.05595 8.13781 3.60477 6.97151 4.39375 5.97675C4.32516 6.83433 4.63388 7.72618 5.21701 8.37794C4.87398 6.73142 5.42283 4.94767 6.5205 3.64419C7.61817 2.3407 9.1275 1.4831 10.7054 0.899963C9.91645 1.72322 9.81354 3.02671 10.1223 4.12441C10.431 5.22208 11.0827 6.18257 11.6659 7.17733C12.249 8.17209 12.7979 9.20117 12.8322 10.3332C13.1409 9.75002 13.4839 9.16685 13.6898 8.51513C13.8956 7.86337 13.9985 7.17733 13.827 6.52557C14.4444 7.28024 14.7875 8.03487 14.959 8.99535C15.1305 9.95584 15.0962 10.9506 14.9933 11.9111C14.8561 12.9745 14.5816 14.0721 13.9985 14.964C13.3125 16.0274 12.2148 16.782 11.0142 17.1936C8.88738 17.571 6.79491 17.2623 5.1827 15.8559Z"
      fill="#F3705A"
    />
    <Path
      d="M7.78948 17.125C10.6023 18.2227 13.3808 14.8954 11.8372 12.3227C11.8372 12.2884 11.8029 12.2883 11.8029 12.2541C11.9401 13.6605 11.597 14.6895 10.9453 15.2727C11.2883 14.4494 11.0482 13.489 10.6366 12.6657C10.2249 11.8768 9.64179 11.1564 9.19585 10.4017C8.7499 9.61278 8.4069 8.7209 8.61271 7.82904C7.78945 8.44649 7.20632 9.37265 6.96619 10.3674C6.72606 11.3622 6.86328 12.4599 7.30923 13.3861C6.79469 13.0087 6.41737 12.3913 6.38306 11.7395C5.83421 12.3913 5.4912 13.2488 5.52548 14.1064C5.52552 15.4442 6.58887 16.6448 7.78948 17.125Z"
      fill="#FFD15C"
    />
  </Svg>
);

export default Fire;
